export default "__VITE_ASSET__CCPonJAg__"